import { useCallback, useEffect, useRef } from "react";

const SIMPLE_TITLE = "EquiDeFi";
const TITLE_FOR_ISSUER = "EquiDeFi Issuer Portal";
const TITLE_FOR_INVESTOR = "EquiDeFi Investor Portal";

const TITLE_MAP = {
  simple: SIMPLE_TITLE,
  issuer: TITLE_FOR_ISSUER,
  investor: TITLE_FOR_INVESTOR,
};

type Piece = string | unknown;
type Pieces = Piece | Piece[];

export const useDocumentTitle = (pieces: Pieces = [], titleType: keyof typeof TITLE_MAP = "simple") => {
  const prevTitle = useRef(document.title);

  const updateTitle = useCallback(() => {
    try {
      /**
       * This allows use the flexibility of passing in an array OR a single string to the
       * hook so that it allows for dynamic title pieces without needing to handle string
       * concatenation in other places
       */
      const start: Piece[] = Array.isArray(pieces) ? pieces : [pieces];
      const title = [...start.filter(Boolean)].filter(Boolean).join(" - ");

      document.title = [title, TITLE_MAP[titleType]].filter(Boolean).join(" | ");
    } catch (err) {
      document.title = prevTitle.current;
    }
  }, [titleType, pieces]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: Run this once on mount
  useEffect(() => {
    updateTitle();

    return () => {
      document.title = prevTitle.current;
    };
  }, []);

  // biome-ignore lint/correctness/useExhaustiveDependencies: If dynamic pieces change, the title should change too
  useEffect(() => updateTitle(), [pieces]);
};
